import { Box, Button, LinearProgress, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StrategyStep } from '../../Utilis/Types/Strategies';
type Props = {
  id: number;
  name: string;
  steps: StrategyStep[];
};
const StepApplication = ({ id, name, steps }: Props) => {
  const [selectedStep, setSelectedStep] = useState(steps[0]);
  const [active, setActive] = useState(0);
  
  const totalTasks = selectedStep?.totalTasks
  const completedTasks = totalTasks - selectedStep?.remainingTasks
  const navigate = useNavigate();
  const progress = (completedTasks / totalTasks) * 100;
  const buffer = ((completedTasks + 1) / totalTasks) * 100;

  return (
    <Box>
      <Typography
        fontSize={'16px'}
        color={'#655C68'}
        fontWeight={'500'}
        lineHeight={'19px'}
        mb={'12px'}
        maxWidth={'400px'}
        textOverflow={'ellipsis'}
        overflow={'hidden'}
        whiteSpace={'nowrap'}
        title={name}
      >
        {name}
      </Typography>
      <Box
        sx={{
          padding: '24px 20px 28px 20px',
          boxShadow: '0px 2px 12px -8px rgba(50, 147, 219, 0.4)',
          border: '1px solid #E5E5E5',
          borderRadius: '4px',
          backgroundColor: '#ffffff',
        }}
      >
        <Typography
          fontSize={'16px'}
          color={'#202A2D'}
          fontWeight={'500'}
          lineHeight={'19px'}
        >
          {selectedStep.name}
        </Typography>

        <ol className='breadcrumb v1'>
          {steps?.map((step: any, i: any) => (
            <li
              style={{ marginBottom: '5px' }}
              key={i}
              onClick={() => {
                setSelectedStep(step);
                setActive(i);
              }}
              className={`breadcrumb-level ${
                i === active && 'breadcrumb-level-active'
              }`}
            >
              <span title={step.name}>{step.name}</span>
            </li>
          ))}
        </ol>
        <Box
          mt={'32px'}
          display={'flex'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography
            fontSize={'16px'}
            color={'#202A2D'}
            fontWeight={'600'}
            lineHeight={'19px'}
          >
            Progress
          </Typography>
          <Typography
            fontSize={'30px'}
            color={'#655C68'}
            fontWeight={'600'}
            lineHeight={'41px'}
          >
            {completedTasks}/{totalTasks}
          </Typography>
        </Box>
        <Box mt={'16px'}>
          <LinearProgress
            variant='determinate'
            value={progress}
            sx={{
              mb: '16px',
            }}
            valueBuffer={buffer}
          />

          <Typography
            fontWeight={'400'}
            fontSize={'14px'}
            lineHeight={'19px'}
            color={'#655C68'}
            variant='caption'
          >
            {selectedStep?.remainingTasks} pending tasks
          </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'center'}>
          <Button
            sx={{
              background: '#3293DB',
              color: '#fff',
              fontSize: '14px',
              fontWeight: '600',
              lineHeight: '17px',
              maxWidth: '250px',
              width: '100%',
              mt: '24px',
            }}
            variant='contained'
            onClick={() =>
              navigate(`/strategies/${id}`)
            }
          >
            Details
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default StepApplication;
